import {
  Button,
  Chip,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownTrigger,
  Input,
  Textarea,
  useDisclosure,
} from "@nextui-org/react";

import React, { useEffect, useState } from "react";

import { FieldList } from "../../utils/constant";
import PreviewForm from "../FormBuilder/PreviewForm";
import {
  UpdateOneData,
  UpdateSingleCollectionData,
  getDataWithFilterUrl,
  getSingleCollectionData,
} from "../../controllers/APIController";
import AddModal from "../FormBuilder/AddModal";
import FieldInfoTable from "../FormBuilder/FieldInfoTable";
import { useNavigate, useParams } from "react-router-dom";
import MetricTagInput from "../FormBuilder/InputField/MetricTagInput";
import { getJSonSchemaFromFieldInfoList, generateUniqueId } from "../../utils/frombuilder.utils";
import { StandardAddButton, StandardSubmitButton } from "../../components/StandardButtons";

const initialFormData = {
  metricName: "",
  className: "",
  description: "",
};



const getFieldInfoListFromGetJSonSchema = (List) => {
  const response = [];
  const fieldOrder = List.fieldOrder || [];
  const properties = List.properties || List; // Fallback to List if no properties field
  
  // Use fieldOrder if available, otherwise use Object.keys
  const keysToProcess = fieldOrder.length > 0 ? fieldOrder : Object.keys(properties);
  
  keysToProcess.forEach((key) => {
    const fieldData = properties[key];
    if (!fieldData) return;
    if (fieldData.type === "relation") {
      response.push({
        id: fieldData.id,
        Title: key,
        Required: fieldData.required,
        Type: fieldData.type,
        name: FieldList[fieldData.type].title,
        relatedTo: fieldData.relatedto,
        metricName: fieldData.metricname,
        isMultiSelect: fieldData.ismultiselect,
      });
    } else if (fieldData.type === "dropdown") {
      response.push({
        id: fieldData.id,
        Title: key,
        Required: fieldData.required,
        Type: fieldData.type,
        name: FieldList[fieldData.type].title,
        values: fieldData.values,
        isMultiSelect: fieldData.ismultiselect,
      });
    } else if (fieldData.type === "integer") {
      response.push({
        id: fieldData.id,
        Title: key,
        Required: fieldData.required,
        Type: fieldData.type,
        name: FieldList[fieldData.type].title,
        min_val: fieldData.min_val,
        max_val: fieldData.max_val,
      });
    } else if (fieldData.type === "slider") {
      response.push({
        id: fieldData.id,
        Title: key,
        Required: fieldData.required,
        Type: fieldData.type,
        name: FieldList[fieldData.type].title,
        min_val: fieldData.min_val,
        max_val: fieldData.max_val,
        step_val: fieldData.step_val,
      });
    } else if (fieldData.type === "text" || fieldData.type === "textarea") {
      response.push({
        id: fieldData.id,
        Title: key,
        Required: fieldData.required,
        Type: fieldData.type,
        name: FieldList[fieldData.type].title,
        char_limit: fieldData?.char_limit || "",
      });
    } else if (fieldData.type === "file") {
      response.push({
        id: fieldData.id,
        Title: key,
        Required: fieldData.required,
        Type: fieldData.type,
        name: FieldList[fieldData.type].title,
        acceptFieldType: fieldData?.acceptfieldtype || [],
      });
    } else {
      response.push({
        id: fieldData.id,
        Title: key,
        Required: fieldData.required,
        Type: fieldData.type,
        name: FieldList[fieldData.type].title,
      });
    }
  });

  return response;
};

const getLinkInfoListFromJson = (list) => {
  const response = [];

  list.forEach((item) => {
    response.push({
      id: item.id,
      Title: item.name,
      link: item.link,
      Type: "link",
      name: "link",
    });
  });
  return response;
};

const getLinkJsonReponse = (list) => {
  const reponse = [];
  list.forEach((item) => {
    reponse.push({
      id: item?.id,
      name: item.Title,
      link: item.link,
    });
  });
  return {
    Links: reponse,
  };
};
const UIMetricBuilderValidation = (formData, fieldInfoList, requiredArr) => {
  const err = {};
  let isValid = true;

  if (fieldInfoList.length === 0) {
    err["BuildData"] = "Build Data should have atleast one field";
    isValid = false;
  }

  Object.keys(formData).forEach((key) => {
    if (requiredArr.includes(key) && formData[key] === "") {
      err[key] = `${key} is required`;
      isValid = false;
    }
  });
  return { isValid: isValid, error: err };
};

const EditUISurveyBuilder = () => {
  const [formData, setFormData] = useState(initialFormData);

  const requiredArr = ["metricName", "categoryName", "jsonSchema"];
  const [validationErrors, setValidationErrors] = useState({});
  const [showPreview, setShowPreview] = useState(false);
  const [previewData, setPreviewData] = useState({});

  const [fieldType, setFieldType] = useState("");
  const [fieldInfoList, setFieldInfoList] = useState([]); // JsonSchema Input field info
  const [LinkInfoList, setLinkInfoList] = useState([]); // Link field info in Metric

  const [userRole, setUserRole] = useState("");
  const UserLogged = JSON.parse(sessionStorage.getItem("userData"));
  const UserId = UserLogged && UserLogged?.user?.id;
  const navigate = useNavigate();

  const { isOpen, onOpen, onOpenChange } = useDisclosure();
  const {
    isOpen: isOpenLink,
    onOpen: onOpenLink,
    onOpenChange: onOpenChangeLink,
  } = useDisclosure();

  const [tags, setTags] = useState([]);
  const [allTags, setAllTags] = useState([]);

  const { _id, _orgId } = useParams();

  const fieldListValues = Object.keys(FieldList).map((key) => {
    return [key, FieldList[key]];
  });
  const changeHandler = (event) => {
    setFormData({ ...formData, [event.target.name]: event.target.value });
  };

  const showPreviewHandler = () => {
    setShowPreview(false);
    const validationResponse = UIMetricBuilderValidation(
      formData,
      fieldInfoList,
      requiredArr
    );

    setValidationErrors(validationResponse.error);
    if (!validationResponse.isValid) {
      return;
    }

    const JsonSchemaData = getJSonSchemaFromFieldInfoList(fieldInfoList);

    const publishData = {
      Name: formData.metricName,
      ClassName: formData.className,
      Description: formData.description,
      JsonSchema: JsonSchemaData,
      Links: getLinkJsonReponse(LinkInfoList),
      TagList: tags,
    };

    setPreviewData(publishData);
    setShowPreview(true);
  };
  const submitHandler = async () => {
    const validationResponse = UIMetricBuilderValidation(
      formData,
      fieldInfoList,
      requiredArr
    );

    if (!validationResponse.isValid) {
      setValidationErrors(validationResponse.error);
      return;
    }
    const JsonSchemaData = getJSonSchemaFromFieldInfoList(fieldInfoList);

    const publishData = {
      Name: formData.metricName,
      ClassName: formData.className,
      Description: formData.description,
      JsonSchema: JsonSchemaData,
      Links: getLinkJsonReponse(LinkInfoList),
      TagList: tags,
    };

    await UpdateOneData("metrics", _id, publishData);

    const newTags = tags?.filter((name) => !allTags?.includes(name));
    const updatedTags = [...allTags, ...newTags];
    await UpdateSingleCollectionData("tag", { List: updatedTags });

    navigate(`/${_orgId}/data-Questionaire`);
    // window.location.reload();
  };

  const addFieldHandler = (listItem) => {
    // Ensure new fields get proper displayOrder
    const newField = {
      ...listItem,
      displayOrder: fieldInfoList.length
    };
    setFieldInfoList([...fieldInfoList, newField]);
  };
  const addLinkHandler = (listItem) => {
    setLinkInfoList([...LinkInfoList, listItem]);
  };

  useEffect(() => {
    const filteredUrl = `filters[id][$eqi]=${_id}`;
    getDataWithFilterUrl("metrics", filteredUrl)
      .then((data) => {
        let response = data.data[0];

        setFormData({
          metricName: response?.attributes?.Name || "",
          categoryName: response?.attributes?.Category || "",
          className: response?.attributes?.ClassName || "",
          description: response?.attributes?.Description || "",
          frameWork: response?.attributes?.Framework?.id || [],
        });

        getFieldInfoListFromGetJSonSchema(
          response?.attributes?.JsonSchema
        );
        setFieldInfoList(
          getFieldInfoListFromGetJSonSchema(
            response?.attributes?.JsonSchema
          )
        );
        setLinkInfoList(
          getLinkInfoListFromJson(response?.attributes?.Links?.Links)
        );

        setTags(response?.attributes?.TagList || []);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [_id]);

  useEffect(() => {
    const userFilteredUrl = "filters[id][$eqi]=" + UserId;
    getDataWithFilterUrl("users", userFilteredUrl)
      .then((data) => {
        setUserRole(data[0]?.role?.name);
      })
      .catch((err) => console.log(err));
  }, [UserId]);

  useEffect(() => {
    getSingleCollectionData("tag")
      .then((data) => {
        setAllTags(data?.data?.attributes?.List);
      })
      .catch((err) => console.log(err));
  }, []);

  return (
    <div className="flex items-start justify-between my-2">
      <div className="flex flex-col items-center w-[50%]">
        {/* Metric Name Input  */}
        <Input
          type="text"
          className="my-4"
          variant="faded"
          isRequired
          label="Metric Name"
          labelPlacement="outside"
          placeholder=" "
          name="metricName"
          value={formData["metricName"]}
          onChange={changeHandler}
          isInvalid={validationErrors["metricName"]}
          errorMessage={
            validationErrors["metricName"] && validationErrors["metricName"]
          }
        />

        {/* ClassName Input */}
        <Input
          type="text"
          className="my-4"
          variant="faded"
          label="Class Name"
          value={formData["className"]}
          placeholder=" "
          labelPlacement="outside"
          name="className"
          onChange={changeHandler}
        />

        {/* Description Input  */}
        <Textarea
          label="Description"
          labelPlacement="outside"
          variant="faded"
          value={formData["description"]}
          className="my-4"
          name="description"
          onChange={changeHandler}
        />

        <MetricTagInput
          tags={tags}
          setTags={setTags}
          IntialvalidationError={null}
          allTags={allTags}
        />

        {/* JsonSchema Input */}

        <div className="w-full min-h-96">
          <div className="flex items-center gap-4">
            <p className="text-lg font-medium">Build your Metric Schema</p>
            <Chip size="sm" radius="sm" color="danger" variant="flat">
              Beta
            </Chip>
          </div>
          {validationErrors["BuildData"] && (
            <p className="text-[#f76497]">{validationErrors["BuildData"]}</p>
          )}
          <p className="my-4 text-sm">
            Choose a data type and begin building your metric forms.
          </p>

          <div className="flex justify-end my-4 mr-4">
            <Dropdown>
              <DropdownTrigger>
                <Button color="primary" size="sm">
                  Add a new field
                </Button>
              </DropdownTrigger>
              <DropdownMenu
                aria-label="Static Actions"
                selectionMode="single"
                onSelectionChange={(event) => {
                  const selectedKey = Array.from(event)[0];
                  // Ensure we have a valid field type
                  if (selectedKey && FieldList[selectedKey]) {
                    setFieldType(selectedKey);
                    onOpen();
                  } else {
                    console.error("Invalid field type selected:", selectedKey);
                  }
                }}
              >
                {fieldListValues.map(
                  (row) =>
                    row[1].name !== "linkUrl" && (
                      <DropdownItem key={row[0]} name={row[0]}>
                        {row[1].title}
                      </DropdownItem>
                    )
                )}
              </DropdownMenu>
            </Dropdown>
          </div>

          {isOpen && (
            <AddModal
              onSubmitHandler={addFieldHandler}
              // id={deleteMetricId}
              modalHeading={"Are you sure you want to delete this Entry?"}
              isOpen={isOpen}
              onOpen={onOpen}
              onOpenChange={onOpenChange}
              fieldType={fieldType}
              id={generateUniqueId('field')}
              existingFields={fieldInfoList.filter(field => field.Type === "dropdown")}
            />
          )}

          <FieldInfoTable
            fieldInfoList={fieldInfoList}
            setFieldInfoList={setFieldInfoList}
          />
        </div>

        {/* Links Input */}

        <div className="w-full min-h-96">
          <div className="flex items-center gap-4">
            <p className="text-lg font-medium">Attach your reference links</p>
            <Chip size="sm" radius="sm" color="danger" variant="flat">
              Beta
            </Chip>
          </div>
          {validationErrors["BuildData"] && (
            <p className="text-[#f76497]">{validationErrors["BuildData"]}</p>
          )}
          <p className="my-4 text-sm">
            Attach reference links for users to fill your metrics easier
          </p>

          <div className="flex justify-end my-4 mr-4">
            <StandardAddButton size="sm" onClick={() => onOpenLink()} aria-label="Add a new link">
              Add a new link
            </StandardAddButton>
          </div>

          {isOpenLink && (
            <AddModal
              onSubmitHandler={addLinkHandler}
              // id={deleteMetricId}
              modalHeading={"Are you sure you want to delete this Entry?"}
              isOpen={isOpenLink}
              onOpen={onOpenLink}
              onOpenChange={onOpenChangeLink}
              fieldType="link"
              id={generateUniqueId('link')}
            />
          )}

          <FieldInfoTable
            fieldInfoList={LinkInfoList}
            setFieldInfoList={setLinkInfoList}
            headersList={["Name", "Link", ""]}
          />
        </div>

        {/* Preview,Submit button */}
        <div className="flex gap-4 my-4 w-full">
          <Button
            color="danger"
            variant="light"
            size="sm"
            onClick={showPreviewHandler}
            aria-label="Preview survey"
          >
            Preview
          </Button>
          <StandardSubmitButton
            size="sm"
            onClick={submitHandler}
            className={`cursor-pointer ${
              userRole !== "Admin" ? "pointer-events-none opacity-50" : ""
            }`}
            aria-label="Submit survey"
          >
            Submit
          </StandardSubmitButton>
        </div>
      </div>

      {/* Preview Card Open */}
      {showPreview && (
        <div className="flex flex-col items-center w-[48%]">
          <PreviewForm data={previewData} />
        </div>
      )}
    </div>
  );
};

export default EditUISurveyBuilder;
